/**
 * PC_BDF_01
 * importing the api function calls
 */
import { useState, useEffect } from "react";
import React from "react";
import { getBankName, getAccountType, postEmployeeBankInfo, getEmployeeBankInfo, getNotificationId/*, encrypData */ } from "../service/DirectorAPI";
import { NotificationTrigger } from '../utils/RegHandling';
import $ from 'jquery';
import { connect } from 'react-redux';
import { encryptStorage } from '../constant'

/**
 * PC_BDF_03 create a function BankDetails() and it will return the HTML
 *
 */
function BankDetails(props) {

    /**
     * PC_BDF_02 creating a variables
     */
    const [DisableSubmitBtn, setDisableSubmitBtn] = useState(false);
    let dataObj = {
        id: "",
        bankname: "selected",
        accounttype: "selected",
        accountnumber: "",
        ifsccode: "",
    };

    const [state, setState] = useState(dataObj);
    let dropDownArrayBankName = [];
    const [arrDropDownbankname, setarrDropDownbankname] = useState(dropDownArrayBankName);
    let dropDownArrayAccountType = [];
    const [arrDropDownaccounttype, setarrDropDownaccounttype] = useState(dropDownArrayAccountType);
    const [reportstoId, setReportstoId] = useState("");


    let oldvalue = {
        bankname: "",
        accounttype: "",
        accountnumber: "",
        ifsccode: "",
    }
    const [Oldvalue, setOldvalue] = useState(oldvalue);
    const [pagemode, setpagemode] = useState("false");
    const [EmpId, setEmpId] = useState("");
    const [submit, setSubmit] = useState("Save");
    const [notification, setNotification] = useState([]);

    let validationFields = {
        bankname: "",
        accounttype: "",
        accountnumber: "",
        ifsccode: ""

    }
    const [message, setmessage] = useState(validationFields);
    const [hideForm, setHideForm] = useState(true);
    let loginEmpId = encryptStorage.getItem("employeeId");
    let role = encryptStorage.getItem("role");

    let rejexFields = {
        bankname: "",
        accounttype: "",
        accountnumber: "",
        ifsccode: ""

    }
    const [rejexErrorMessage, setRejexErrorMessage] = useState(rejexFields);

    /**
     * PC_BDF_03 useEffect method get invoked and make a dropdown api calls
     */
    useEffect(() => {
        setDisableSubmitBtn(false);

        //encrypt('ManagerRole');
    }, [props.IsBankClick]);


    useEffect(() => {
        if (props.IsBankClick) {

            // let element = document.getElementById("removeScroll");
            // element.classList.add("removeScroll");

            $("body").addClass("removeScroll");

            LoadBankName();
            LoadAccountType();
            setHideForm(false);

            if (props.empId != undefined) {
                setEmpId(props.empId)
            }
            if (props.Mode != undefined) {
                if (props.Mode == 'Edit') {
                    setpagemode('true')
                    setSubmit('Update')
                } else {
                    setpagemode('false')
                    setSubmit('Save')
                }
            }
            if (props.Id != undefined) {

                let objedit = {

                    emp_id: props.empId,
                    id: props.Id,
                    reports_to: loginEmpId,
                    role: role,
                };

                selecteditarray(objedit);
            }
        }

    }, [props])
    /**
     * PC_BDF_04 this function get the data from DB and store into the state variable
     */
    const LoadBankName = async () => {
        let bankData = {};
        let responsedata = await getBankName(bankData);
        setarrDropDownbankname(responsedata.data.ResponseData[0]);
    };

    // const EditLoadBankName = async () => {
    //     let bankData = {};
    //     let responsedata = await getBankName(bankData);
    //     setarrDropDownbankname(responsedata.data.ResponseData[0]);
    // };

    // const encrypt = async (Inputvalue) => {
   
    //     let bankData = { value: Inputvalue };
    //     let encrypting = await encrypData(bankData);
    //     
    // };



    const LoadAccountType = async () => {
        let AccountTypeData = {};
        let responsedata = await getAccountType(AccountTypeData);
        setarrDropDownaccounttype(responsedata.data.ResponseData[0]);
    };

    // const EditoadAccountType = async () => {
    //     let AccountTypeData = {};
    //     let responsedata = await getAccountType(AccountTypeData);
    //     setarrDropDownaccounttype(responsedata.data.ResponseData[0]);
    // };

    /**
     * 
     * PC_BDF_11 this function set the input value into the respective variable
     */
    const OnChangeName = (e) => {
        setState({ ...state, [e.target.name]: e.target.value });
        setmessage({ ...message, [e.target.name]: "" });

        let regexItem;
        let checkValid;

        if (e.target.name == "accountnumber") {
            regexItem = new RegExp("^[a-zA-Z0-9]*$");
            checkValid = regexItem.test(e.target.value);
            if (checkValid == false) {

                setRejexErrorMessage({ ...rejexErrorMessage, [e.target.name]: "Enter a Valid Account Number" });

            } else {
                setRejexErrorMessage({ ...rejexErrorMessage, [e.target.name]: "" });
            }
        }

        if (e.target.name == "ifsccode") {
            regexItem = new RegExp("^[a-zA-Z0-9]*$");
            checkValid = regexItem.test(e.target.value);
            if (checkValid == false) {

                setRejexErrorMessage({ ...rejexErrorMessage, [e.target.name]: "Enter a Valid IFSC Code" });

            } else {
                setRejexErrorMessage({ ...rejexErrorMessage, [e.target.name]: "" });
            }
        }

    };


    /**
     * 
     * PC_BDF_10 this function bind the value into the dropdown 
     */
    const buildBankName = () => {
        return arrDropDownbankname.map((value, index) => {
            return <option value={value.id}>{value.name}</option>;
        });
    };
    const buildAccountType = () => {
        return arrDropDownaccounttype.map((value, index) => {
            return <option value={value.id}>{value.name}</option>;
        });
    };

    /**
     * PC_BDF_12 validation function validate the 
     * input data and show the error message
     */
    const validation = () => {

        if (state.bankname == "selected" || state.bankname == "select" || state.bankname == "") {

            message.bankname = "Name of the bank is required"
            setmessage({ ...message });
        } else {
            message.bankname = ""
            setmessage({ ...message });

        }
        if (state.accounttype == "selected" || state.accounttype == "select" || state.accounttype == "") {

            message.accounttype = "Account type is required"
            setmessage({ ...message });

        } else {
            message.accounttype = ""
            setmessage({ ...message });

        }
        if (state.accountnumber.trim() == "") {

            message.accountnumber = "Account number is required"
            setmessage({ ...message });

        } else {
            message.accountnumber = ""
            setmessage({ ...message });

            // let checkregex = OnlyNumberSpecialChar(state.accountnumber)
            // if (checkregex) {

            //     message.accountnumber = "Enter a Valid Account number"
            //     setmessage({ ...message });
            // } else {
            //     message.accountnumber = ""
            //     setmessage({ ...message });

            // }

        }
        if (state.ifsccode.trim() == "") {

            message.ifsccode = "IFSC code is required"
            setmessage({ ...message });

        } else {
            message.ifsccode = ""
            setmessage({ ...message });

            // let checkregex = OnlyNumberSpecialChar(state.ifsccode)
            // if (checkregex) {

            //     message.ifsccode = "Enter a Valid IFSC code"
            //     setmessage({ ...message });
            // } else {
            //     message.ifsccode = ""
            //     setmessage({ ...message });

            // }

        }

    }

    /**
     * PC_BDF_11.1 clear the fields when user clicks the cancel and close button
     */
    const cancelClick = () => {

        let valiclearoption = {
            id: "",
            bankname: "selected",
            accounttype: "selected",
            accountnumber: "",
            ifsccode: "",
        };
        setState(valiclearoption);

        let validationFields = {
            bankname: "",
            accounttype: "",
            accountnumber: "",
            ifsccode: ""

        }
        setmessage(validationFields);

        props.setIsBankClicked(false);
        setHideForm(true);

        // let element = document.getElementById("removeScroll");
        // element.classList.remove("removeScroll");

        $("body").removeClass("removeScroll");

    }

    /**
     * PC_BDF_13 this function validate the data and post into the database
     */
    const submitClick = async () => {
        try {
              setDisableSubmitBtn(true);
            validation();

            let isRejexValid = true;
            if (rejexErrorMessage.ifsccode != "" || rejexErrorMessage.accountnumber != "") {
                isRejexValid = false;
            } else {
                isRejexValid = true;
            }

            /**
             * PC_BDF_19 this will make a post call to insert the data into the batadase
             */
            if (pagemode == "false" && isRejexValid == true) {
                if (
                    state.bankname != "" &&
                    state.accounttype != "" &&
                    state.accountnumber.trim() != "" &&
                    state.ifsccode.trim() != ""
                ) {
                    let insertdata = {
                        request_type: "Insert", //
                        emp_id: EmpId, //
                        login_emp_id: loginEmpId, //
                        bank_name: state.bankname,
                        account_type: state.accounttype,
                        account_number: state.accountnumber,
                        ifsc_code: state.ifsccode,
                        role: role
                    };

                    let responsedata = await postEmployeeBankInfo(insertdata);
                    if (responsedata.data.status == 200) {
                        let valiclearoption = {
                            id: "",
                            bankname: "selected",
                            accounttype: "selected",
                            accountnumber: "",
                            ifsccode: "",
                        };
                        setState(valiclearoption);

                        props.setIsBankClicked(false);
                        props.getEmployeeBankGrid();
                        cancelClick();
                        props.showToast('Submitted', 'Submitted Succesfully');

                    }

                }
            }
            /**
            * PC_BDF_31.1 if the role is HR Manager the update will made directly with proper payload
            */
            else if (pagemode == "true" && isRejexValid == true) {

                if (((role == "Hr Manager" || role == "Hr") && loginEmpId != EmpId) || (role == "Hr Manager" && loginEmpId == EmpId && reportstoId == loginEmpId)) {    // || reportstoId == loginEmpId
                    if (
                        state.bankname != "" &&
                        state.accounttype != "" &&
                        state.accountnumber.trim() != "" &&
                        state.ifsccode.trim() != ""
                    ) {
                        let updatedata = {
                            request_type: "Update",
                            emp_id: EmpId,
                            login_emp_id: loginEmpId,
                            id: state.id,
                            bank_name: state.bankname,
                            account_type: state.accounttype,
                            account_number: state.accountnumber,
                            ifsc_code: state.ifsccode,
                            role: role

                        };

                        let responsedata = await postEmployeeBankInfo(updatedata);
                        if (responsedata.data.status == 200) {

                            let valiclearoption = {
                                id: "",
                                bankname: "selected",
                                accounttype: "selected",
                                accountnumber: "",
                                ifsccode: "",
                            };
                            setState(valiclearoption);

                            props.setIsBankClicked(false);
                            props.getEmployeeBankGrid();
                            cancelClick();
                            props.showToast('Updated', 'Updated Succesfully');
                        }
                    }

                    /***
                    * PC_BDF_32.2 if the role is Team Member
                    * dymamically binding the payload object for current and permanent address
                    */
                } else if (role == "Team Member" || loginEmpId == EmpId) {
                    if (
                        state.bankname != "" &&
                        state.accounttype != "" &&
                        state.accountnumber.trim() != "" &&
                        state.ifsccode.trim() != ""
                    ) {

                        let newvalue = {
                            bank_name: state.bankname,
                            account_type: state.accounttype,
                            account_number: state.accountnumber,
                            ifsc_code: state.ifsccode,
                        }

                        let oldvalue = {
                            bank_name: Oldvalue.bankname,
                            account_type: Oldvalue.accounttype,
                            account_number: Oldvalue.accountnumber,
                            ifsc_code: Oldvalue.ifsccode,
                        }

                        var NewValue = Object.keys(newvalue);
                        var OldValue = Object.keys(oldvalue);
                        var log_data = '{';
                        for (let i = 0; i <= NewValue.length; i++) {
                            if (newvalue[NewValue[i]] != oldvalue[OldValue[i]]) {

                                log_data += '"' + NewValue[i] + '"' + ':' + '"' + "'" + newvalue[NewValue[i]] + "'" + ',' + "'" + oldvalue[OldValue[i]] + "'" + '"' + ',';
                            }
                            if (i == NewValue.length) {

                                log_data = log_data.slice(0, -1);
                                log_data = log_data + "}";
                            }
                        }
                        ;

                        if (log_data != '{' && log_data != '}') {

                            let logData = JSON.parse(log_data);
                            let updatedata = {
                                request_type: "Update",
                                emp_id: EmpId,
                                login_emp_id: loginEmpId,
                                category_id: state.id,
                                category: "emp_account_detail",
                                status: "Pending",
                                role: "Team Member",
                                log_data: logData

                            };

                            let emp = [];
                            notification.map((obj, index) => {

                                emp.push(obj.emp_id);
                            });

                            if (Object.keys(logData).length > 0) {

                                let responsedata = await postEmployeeBankInfo(updatedata);
                                if (responsedata.data.status == 200) {
                                    let profileRequestId = responsedata.data.ResponseData[1];
                                    await NotificationTrigger({ title: "Profile Update", message: 'Profile Request', route: '/profileupdate', state: { state: { profileRequestId: profileRequestId } }, to_employee: emp, by: loginEmpId }, emp, props.websocket)
                                    let valiclearoption = {
                                        id: "",
                                        bankname: "selected",
                                        accounttype: "selected",
                                        accountnumber: "",
                                        ifsccode: "",
                                    };
                                    setState(valiclearoption);
                                    props.setIsBankClicked(false);
                                    cancelClick();
                                    props.showToast('Profile Request submitted', 'Changes will be reflected after the approval');
                                }
                            }
                        } else {
                            cancelClick();
                        }
                    }
                }
            }
            setDisableSubmitBtn(false);
        } catch (e) {
            setDisableSubmitBtn(false);

        }

    }

    /**
     * 
     * PC_BDF_20 this function get the record from DB and bind into the respective fields
     */
    const selecteditarray = async (objedit) => {

        try {
            let responsedata = await getEmployeeBankInfo(objedit);
            if (responsedata.data != undefined && responsedata.data != null && responsedata.data.ResponseData[0].length != 0) {

                let oldvalueobj = {

                    bankname: responsedata.data.ResponseData[0][0].bank_name,
                    accounttype: responsedata.data.ResponseData[0][0].account_type,
                    accountnumber: responsedata.data.ResponseData[0][0].account_number,
                    ifsccode: responsedata.data.ResponseData[0][0].ifsc_code,
                }
                setOldvalue(oldvalueobj);

                let valiDateobj1 = {
                    id: responsedata.data.ResponseData[0][0].id,
                    bankname: responsedata.data.ResponseData[0][0].bank_name,
                    accounttype: responsedata.data.ResponseData[0][0].account_type,
                    accountnumber: responsedata.data.ResponseData[0][0].account_number,
                    ifsccode: responsedata.data.ResponseData[0][0].ifsc_code,
                };
                setState(valiDateobj1);
            }

            let NotaficationData = await getNotificationId(objedit);
            setNotification(NotaficationData.data.ResponseData[0]);
            setReportstoId(NotaficationData?.data?.ResponseData[0][0]?.emp_id);


        } catch (e) {

        }
    };


    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)' }} hidden={hideForm}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <h5 className="modal-title profile-popup-header" id="BankDetailsPopupLabel">
                            Bank Details
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => cancelClick()}
                        />
                    </div>
                    <div className="modal-body">
                        <div className="row mb-1">
                            <div className="col-md-6 mb-4">
                                <label htmlFor="bankdetails-name" className="form-label hive-form-label">
                                    Name of the Bank<span className="hive-form-mandatory">*</span>
                                </label>
                                <select
                                    className="form-select hive-form-select"
                                    aria-label="Default select example"
                                    id="bankdetails-name"
                                    name="bankname"
                                    value={state.bankname}
                                    onChange={(e) => {
                                        OnChangeName(e);
                                    }}
                                >
                                    <option selected>select</option>
                                    {buildBankName()}
                                </select>
                                {message.bankname ? <label className="hive-form-mandatory">{message.bankname}</label> : null}
                            </div>
                            <div className="col-md-6 mb-4">
                                <label htmlFor="bankdetails-accounttype" className="form-label hive-form-label">
                                    Account Type<span className="hive-form-mandatory">*</span>
                                </label>
                                <select
                                    className="form-select hive-form-select"
                                    aria-label="Default select example"
                                    id="bankdetails-accounttype"
                                    name="accounttype"
                                    value={state.accounttype}
                                    onChange={(e) => {
                                        OnChangeName(e);
                                    }}
                                >
                                    <option selected>select</option>
                                    {buildAccountType()}
                                </select>
                                {message.accounttype ? <label className="hive-form-mandatory">{message.accounttype}</label> : null}
                            </div>
                            <div className="col-md-6 mb-4">
                                <label htmlFor="bankdetails-accountnumber" className="form-label hive-form-label">
                                    Account Number<span className="hive-form-mandatory">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control hive-form-control"
                                    id="bankdetails-accountnumber"
                                    aria-describedby="Account Number"
                                    maxlength={17}
                                    placeholder="Enter Account Number"
                                    name="accountnumber"
                                    value={state.accountnumber}
                                    onChange={(e) => {
                                        OnChangeName(e);
                                    }}
                                />
                                {message.accountnumber ? <label className="hive-form-mandatory">{message.accountnumber}</label> : null}
                                {rejexErrorMessage.accountnumber ? (
                                    <label className="hive-form-mandatory">{rejexErrorMessage.accountnumber}</label>
                                ) : null}
                            </div>
                            <div className="col-md-6 mb-4">
                                <label htmlFor="bankdetails-ifsc" className="form-label hive-form-label">
                                    IFSC Code<span className="hive-form-mandatory">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control hive-form-control"
                                    id="bankdetails-ifsc"
                                    aria-describedby="IFSC Code"
                                    placeholder="Enter IFSC Code"
                                    maxlength={11}
                                    name="ifsccode"
                                    value={state.ifsccode}
                                    onChange={(e) => {
                                        OnChangeName(e);
                                    }}
                                />
                                {message.ifsccode ? <label className="hive-form-mandatory">{message.ifsccode}</label> : null}
                                {rejexErrorMessage.ifsccode ? (
                                    <label className="hive-form-mandatory">{rejexErrorMessage.ifsccode}</label>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer border-0">
                        <button type="button" className="btn hive-btn-secondary" data-bs-dismiss="modal" onClick={() => cancelClick()}>
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn hive-btn-primary"
                            onClick={() => {
                                submitClick();
                            }}
                            disabled={DisableSubmitBtn}
                        >
                            {submit}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {

    return {
        websocket: state.webSocketAPI
    }
}

export default connect(mapStateToProps)(BankDetails)